import { connect } from "react-redux";

var StudentMetrics = require("lib/data/StudentMetrics");
var GradeLevel = require("lib/academic/GradeLevel");
var OrgTypes = require("lib/academic/OrgTypes");
var CurrentUser = require("lib/account/CurrentUser");

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

var DataSelectors = require('lib/selectors/DataSelectors');
var RosterSelectors = require('lib/selectors/RosterSelectors');
var RosterActions = require("lib/actions/RosterActions");

var OrgActivityRouting = require("lib/routing/OrgActivityRouting");
var DataRouting = require("lib/routing/DataRouting");

require("data/org_reports/org_activity_table.scss");

@connect(
	(state, props) => ({
		userMetricsColumns: DataSelectors.dashboardOtherMetrics({
			state, count: 4, aggregate: true
		}),

		getStudentListAdmin: (studentListID) => {
			return RosterSelectors.primaryAdminForStudentListID({ state, studentListID });
		},

		getStudentListSchoolName: (studentListID) => {
			var studentList = RosterSelectors.studentList({ state, id: studentListID });
			var schoolOrg = RosterSelectors.schoolOrg({ state, id: studentList.school_org_id });

			if (schoolOrg) {
				return schoolOrg.name;
			}
		},

		getClassCount: (schoolOrgID) => {
			return RosterSelectors.studentLists({ state, filters: { school_org_id: schoolOrgID } }).length;
		},

		getStudentCount: (orgIdentifier) => {
			return RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier }).length
		},

		getStudentIDs: (orgIdentifier) => {
			return _.pluck(RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier }), "id")
		}

		// loading: DataSelectors.isLoadingDigests({ state }),
	}),
	(dispatch, props) => ({
		updateDashboardColumns: (newCols) =>
			dispatch(
				RosterActions.updateAdmin({
					id: CurrentUser.get().id,
					update: { prefs: { dashboard_columns: newCols } },
				}),
			).then(() => {
				const prefs = { ...CurrentUser.get().prefs, dashboard_columns: newCols };
				CurrentUser.updateLocal({ prefs });
			}),

	})
)
class OrgActivityTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { orderBy: NAME_ORDER };
	}

	isStudentListTable() {
		return this.props.orgType === OrgTypes.STUDENT_LIST;
	}

	isMultiSchoolStudentListTable() {
		if (!this.isStudentListTable()) {
			return false;
		}

		return _.uniq(_.pluck(this.props.orgs, "school_org_id")).length > 1;
	}

	isSchoolOrgTable() {
		return this.props.orgType === OrgTypes.SCHOOL_ORG;		
	}

	selectExtraColumn(extraColumnIndex, columnKey) {
		var newDashboardColumns = _.clone(this.props.userMetricsColumns);
		newDashboardColumns[extraColumnIndex] = columnKey;

		newDashboardColumns = _.uniq(_.compact(newDashboardColumns))
		
		if (_.isEqual(this.props.userMetricsColumns, newDashboardColumns)) {
			return;
		}

		this.props.updateDashboardColumns(newDashboardColumns).then(() => {
			return this.props.reloadF()
		});
	}

	changeSortBy(orderBy) {
		this.setState({ orderBy });
	}

	digest(org) {
		var base = { org_identifier: this.toIdentifier(org) };
		var digest = _.findWhere(this.props.digests, base);

		if (digest) {
			return digest;
		}

		return base;
	}

	statCellCount() {
		return 5; // 1 for students / grade level, plus 4 metrics
	}
	statCellWidth() {
		return (100 - this.infoCellWidth()) / this.statCellCount();
	}
	infoCellWidth() {
		return 26;
	}

	toIdentifier(org) {
		if (this.isStudentListTable() || this.isSchoolOrgTable()) {
			return OrgTypes.toIdentifier({ type: this.props.orgType, key: org.id });
		}
	}

	onRowClick(org) {
		if (this.isSchoolOrgTable()) {
			this.props.onChangeView({
				orgIdentifier: this.toIdentifier(org)
			})
		} else if (this.isStudentListTable()) {
			console.log(DataRouting.getPath({
				subjectType: DataRouting.SUBJECT_OTHER_METRICS,
				userIDs: this.props.getStudentIDs(this.toIdentifier(org))
			}))
			$wr.redirect(DataRouting.getPath({
				subjectType: DataRouting.SUBJECT_OTHER_METRICS,
				userIDs: this.props.getStudentIDs(this.toIdentifier(org))
			}))
		}
	}

	sortedOrgs() {
		if (StudentMetrics.isMetric(this.state.orderBy)) {
			var digestKey = StudentMetrics.getDigestEmbeds([this.state.orderBy]).split(",")[0];

			var toDigest = (org) => {
				return this.digest(org)[digestKey] || 0;
			}

			return _.sortBy(this.props.orgs, toDigest).reverse();

		} else if (this.state.orderBy === GRADE_LEVEL) {
			return _.sortBy(this.props.orgs, "grade_level");

		} else if (this.state.orderBy === TEACHER_NAME) {
			return _.sortBy(this.props.orgs, (studentList) => {
				var teacher = this.props.getStudentListAdmin(studentList.id);
				if (teacher) {
					return (teacher.last_name + ", " + teacher.first_name).toUpperCase();
				} else {
					return "ZZZ";
				}
			});

		} else if (this.state.orderBy === SCHOOL_NAME_ORDER) {
			return _.sortBy(
				this.props.orgs,
				(studentList) => this.props.getStudentListSchoolName(studentList.id)
			);

		} else if (this.state.orderBy === STUDENT_COUNT) {
			return _.sortBy(
				this.props.orgs,
				(org) => this.props.getStudentCount(this.toIdentifier(org))
			).reverse();

		} else {
			return _.sortBy(this.props.orgs, "name");
		}

		return 
	}

	renderSortControl() {
		var orderOptionText = (op) => {
			if (op === NAME_ORDER) {
				if (this.isStudentListTable()) {
					return "Class Name";
				} else {
					return "School Name";
				}
			} else if (op === SCHOOL_NAME_ORDER) {
				return "School Name";

			} else if (op === GRADE_LEVEL) {
				return "Grade Level";

			} else if (op === TEACHER_NAME) {
				return "Teacher Name";

			} else if (op === STUDENT_COUNT) {
				return "Number of Students";

			} else {
				return StudentMetrics.getLabel(op);
			}
		}

		var renderOption = (op) => {
			return (
				<ButtonDropdownOption key={ op } className=""
					text={ orderOptionText(op) }
					onClick={ this.changeSortBy.bind(this, op) }>
				</ButtonDropdownOption>
			);
		}

		var orderOptions = [];

		orderOptions.push(renderOption(NAME_ORDER));


		if (this.isStudentListTable()) {
			if (this.isMultiSchoolStudentListTable()) {
				orderOptions.push(renderOption(SCHOOL_NAME_ORDER));
			} else {
				orderOptions.push(renderOption(TEACHER_NAME));
			}
			orderOptions.push(renderOption(GRADE_LEVEL));
		}

		orderOptions.push(renderOption(STUDENT_COUNT));

		_.each(this.props.userMetricsColumns, (metric) => {
			orderOptions.push(renderOption(metric));
		});

		var displayText = orderOptionText(this.state.orderBy);

		return (
			<ButtonDropdown dropdownDisplay="link" text={ displayText }>
				{ orderOptions }
			</ButtonDropdown>
		);
	}


	renderMetricOptions(metrics, extraColIndex) {
		metrics = _.reject(metrics, (m) => {
			return _.contains(this.props.userMetricsColumns, m);
		})
		return metrics.map((columnKey) => {
			return (
				<ButtonDropdownOption
					onClick={this.selectExtraColumn.bind(
						this,
						extraColIndex,
						columnKey,
					)}
					text={StudentMetrics.getLabel(columnKey)}
					key={columnKey}
				/>
			);
		})
	}

	renderTableHeaders() {
		// Index of this extra column (which are all on the right)
		var extraColIndex = 0;

		var headerCells = _.map(this.props.userMetricsColumns, (col, extraColIndex) => {

			var cellContents = (
				<ButtonDropdown dropdownDisplay="link" text={StudentMetrics.getLabel(col)}>
					{ this.renderMetricOptions(StudentMetrics.aggregateMetrics(), extraColIndex) }
				</ButtonDropdown>
			);

			return (
				<div className="statSection" key={ col } style={{ width: this.statCellWidth() + "%" }}>
					{ cellContents }
				</div>
			);
		});


		return (
			<div className="orgRow headerRow">
				<div className="infoSection sortControlCell hideOnPrint"
					style={{ width: this.infoCellWidth() + "%" }}>
					Sort By: { this.renderSortControl() }
				</div>

				<div className="statSection" style={{ width: this.statCellWidth() + "%" }}></div>
				{ headerCells }
			</div>
		);
	}

	renderTableRows() {
		return this.sortedOrgs().map((org, index) => {
			var digest = this.digest(org);

			var statCells = this.props.userMetricsColumns.map((metric) => {
				return (
					<div className="statSection" key={ metric }
						style={{ width: this.statCellWidth() + "%" }}>
						{ StudentMetrics.getValue(digest, metric) || 0 }
					</div>
				);
			})

			var nameText = org.name;

			if (this.isStudentListTable()) {
				if (this.isMultiSchoolStudentListTable()) {
					var nameSubText = (
						<div className="subText ellipsisText">
							{ this.props.getStudentListSchoolName(org.id) }
						</div>
					);

				} else {
					var teacher = this.props.getStudentListAdmin(org.id);

					if (teacher) {
						var nameSubText = (
							<div className="subText ellipsisText">
								Teacher: { teacher.first_name } { teacher.last_name }
							</div>
						);
					}
				}

				var studentsSubText = (
					<div className="subText">
						{ GradeLevel.getName(org.grade_level) }
					</div>
				);
			} else {
				var classCount = this.props.getClassCount(org.id)
				var nameSubText = (
					<div className="subText ellipsisText">
						{ $wr.pluralizeWithNumber("class", classCount, "classes") }
					</div>
				);

			}

			var studentCount = this.props.getStudentCount(digest.org_identifier);

			return (
				<div className="orgRow clickableElement" key={ digest.org_identifier }
					onClick={ () => this.onRowClick(org) }>
					<div className="infoSection"
						style={{ width: this.infoCellWidth() + "%" }}>
						{ nameText }
						{ nameSubText }
					</div>
					<div className="statSection" style={{ width: this.statCellWidth() + "%" }}>
						{ $wr.pluralizeWithNumber("student", studentCount) }
						{ studentsSubText }
					</div>

					{ statCells }
				</div>
			);
		})
	}

	renderEmptyState() {
		if (this.props.orgs.length) {
			return;
		}

		return (
			<div className="adminEmptyState">
				No classes have been added yet! Classes will show up here as
				teachers activate and set up their accounts.
			</div>
		);
	}

	render() {
		return (
			<div className="orgActivityTable">
				{ this.renderTableHeaders() }
				{ this.renderTableRows() }
				{ this.renderEmptyState() }
			</div>
		);
	}
}

var NAME_ORDER = "class-name";
var SCHOOL_NAME_ORDER = "school-name";
var TEACHER_NAME = "teacher-name";
var GRADE_LEVEL = "grade-level";
var STUDENT_COUNT = "student-count";

OrgActivityTable.WrappedComponent.propTypes = PageStrictPropTypes({
	digests: PropTypes.array,
	orgs: PropTypes.array,
	orgType: PropTypes.string,
	reloadF: PropTypes.func,
	onChangeView: PropTypes.func,

	// Data from @connect
	userMetricsColumns: PropTypes.array,

	// Data getters from @connect
	getStudentListAdmin: PropTypes.func,
	getSchoolOrgAdmin: PropTypes.func,
	getStudentCount: PropTypes.func,
	getClassCount: PropTypes.func,
	getStudentIDs: PropTypes.func,
	getStudentListSchoolName: PropTypes.func,

	// Handlers from @connect
	updateDashboardColumns: PropTypes.func
})

module.exports = OrgActivityTable;


// WEBPACK FOOTER //
// ./modules/components/data/org_reports/OrgActivityTable.js